import React from "react";
import * as modalDataService from "./modalDataService";
import { debug } from "../../utils";
import { connect } from "react-redux";

function EnableSyslogProcessingField({ enableSyslogProcessing }) {

    const onChange = (value) => {
        modalDataService.changeEnableSyslogProcessing(value);

        if (!value) {
            modalDataService.unselectAllEvents();
        }
    };

    return (
        <div className={`modal-v2-step3-toggle-card ${enableSyslogProcessing ? "is-active" : ""}`}>
            <label className="modal-v2-step3-toggle-label">
                <input
                    type="checkbox"
                    checked={!!enableSyslogProcessing}
                    onChange={() => onChange(!enableSyslogProcessing)}
                />

                <span className="modal-v2-step3-toggle-box" aria-hidden="true">
                    <span className="modal-v2-step3-toggle-check">✓</span>
                </span>

                <span className="modal-v2-step3-toggle-copy">
                    <span className="modal-v2-step3-toggle-title">Enable Syslog Processing</span>
                    <span className="modal-v2-step3-toggle-help">
                        Collect, classify, and route syslog events for this device.
                    </span>
                </span>
            </label>
        </div>
    );
}

function mapStateToProps(state) {
    debug("EnableSyslogProcessingField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        enableSyslogProcessing: addDeviceModal.enableSyslogProcessing || false
    };
}

export default connect(mapStateToProps)(EnableSyslogProcessingField);
